import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./ProdukSwipeCard.css";
import apiClient from "../components/apiClient";
import { Box, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";
import { useParams } from "react-router-dom";

const formatRupiah = (angka) => {
  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 0,
  }).format(angka);
};

const BlogSwiper = () => {
  const { id } = useParams();
  const [produkList, setProdukList] = useState([]);
  const [cashbackList, setCashbackList] = useState({});
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const baseURL = process.env.REACT_APP_BASE_URL || "http://192.168.1.3:2000";
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await apiClient.get("/blog");
        // setBlogs(res.data.blog || []);
        const allBlogs = res.data.blog || [];
        setBlogs(allBlogs.slice(0, 4));
      } catch (err) {
        console.error("Failed to fetch blogs:", err);
      }
    };

    fetchBlogs();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [produkResponse, cashbackResponse] = await Promise.all([
          // axios.get(`${baseURL}/produk`),
          // axios.get(`${baseURL}/produk/limit?limit=6`),
          // axios.get(`${baseURL}/cashback`),
          // apiClient.get(`/produk/limit?limit=6`),
          apiClient.get(`/blog`),
          // apiClient.get("/produk/all", {
          //   params: { limit: 4 }, // Pass limit as query parameters
          // }),
    
        ]);

        setProdukList(produkResponse.data);

        // Convert cashback list to a dictionary for fast lookups
     
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [baseURL]);

  const handleCardClick = (nama_produk) => {
    // navigate(`/produk/all/${nama_produk}`);
    navigate(`/all-produk/${nama_produk}`);
  };

  const handleSeeAllClick = () => {
    navigate("/blog-page");
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <section className="w-full py-8">
      {/* Header Section */}
      <section className="pl-4 w-full text-center">
        <h1 className="text-xl md:text-4xl font-bold text-black">
          Title About Blog
        </h1>
      </section>

      {/* Product Cards Section */}
      {/* <section className="produk-card-container grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-0 px-0"> */}
      <section className="bg-white py-14 md:px-10 relative w-full">
        {/* Centering Content */}
        <div className="p-2 md:p-8 grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-3 md:gap-8">
          {blogs.map((blog) => (
            <div
              key={blog.id}
              className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow w-auto"
            >
              <Link to={`/blog-detail/${blog.id}`}>
                <img
                  src={blog.image}
                  alt={blog.judul}
                  className="p-2 md:p-3 w-full h-48 object-cover"
                />
                <div className="p-4">
                  <h3 className="font-semibold text-lg mb-2">{blog.judul}</h3>
                  <p className="text-gray-600 text-sm line-clamp-2">
                    {blog.meta_desc || "No description"}
                  </p>
                  <p className="mt-2 text-xs text-gray-400">
                    By {blog.adminnama} •{" "}
                    {new Date(blog.createdAt).toLocaleDateString("id-ID", {
                      year: "numeric",
                      month: "short",
                      day: "numeric",
                    })}
                  </p>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </section>

      {/* "See All" Button - Takes Minimal Space */}
      <div className="mx-auto flex justify-center items-center w-fit mt-4">
        <button
          onClick={handleSeeAllClick}
          className="rounded-lg bg-black text-white h-auto p-3 px-6 hover:bg-yellow-600 transition duration-300 text-s w-full"
        >
          View All Blogs
        </button>
      </div>

      {/* See All Button */}
      {/* <div className="text-center mt-8">
        <button
          onClick={handleSeeAllClick}
          className="see-all-button bg-blue-500 text-white py-2 px-6 rounded-lg hover:bg-blue-600 transition-colors duration-300"
        >
          See All
        </button>
      </div> */}
    </section>
  );
};

export default BlogSwiper;
